import React from "react";
import { CreateOrEditUserRolePage } from "~/areas/configuration/components/Roles/CreateOrEditUserRolePage";
export function CreateUserRolePage() {
    return <CreateOrEditUserRolePage roleId={undefined}/>;
}
